document.addEventListener('DOMContentLoaded', () => {

  function bindA() {
    const a = document.querySelector('.size-info-inl-text a');
    const returnAc = document.querySelector('.is-return-tab');
    
    if(!a || !returnAc) return;
  
    a.href = '#'+returnAc.id;
  
    a.addEventListener('click', (event) => {
      event.preventDefault();
        returnAc.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
  
        setTimeout(() => {
          returnAc.querySelector('button')?.click();
        }, 500);
    });
  }

  bindA();

  document.addEventListener('nwt_product:rendered', (e) => {
    bindA();
  });

});